/**
 * Q276(사용자 결정 2026-10-13) — 메뉴 › 시스템 › **소식**. 전에는 도움말 창 안의 접힌 칸이었다.
 *
 * 창을 연 순간 새 글이던 것에 「새」를 붙이고 최신 날짜부터 제목을 보여 준다. pin은 주요 안내 표식으로 남기며, 최근 8건 뒤는
 * 「지난 소식」으로 접는다(기록은 지우지 않는다 — 같은 주제가 연달아 바뀐 글도 그대로 다 남는다).
 * ⚠ **여기서 `markNewsRead()` 를 부르지 않는다** — 그리는 것과 읽은 것은 다르다. 창을 **실제로 연** 순간에 부른다
 * (`panels/index.js` togglePanel). 여기서 부르면 검사기가 화면을 그려보기만 해도 읽은 것이 된다.
 */
import { newsNow, newsFresh } from '../news.js';
import { muted, sec } from './common.js';
import { esc } from '../../core/state.js';

const NEWS_SHOWN = 8;

/** 게임 밖의 긴 소개와 패치 기록으로 이어지는 두 문. 전투 화면은 가리지 않는다. */
function webzineSec() {
  return sec('유니지 웹진 · 소개와 패치 노트', `
    <div class="reading-links" aria-label="유니지 웹진">
      <a class="reading-link" href="/zine/" target="_blank" rel="noopener noreferrer">
        <span><b>세계 소개</b><small>처음 온 사람을 위한 이야기와 규칙</small></span><em>↗</em>
      </a>
      <a class="reading-link" href="/zine/#patchnotes" target="_blank" rel="noopener noreferrer">
        <span><b>패치 노트</b><small>본서버에 반영된 변경 기록</small></span><em>↗</em>
      </a>
    </div>`);
}

export function render() {
  const all = newsNow(); // 플래그 항목(초대 이벤트)은 서버 켬끔을 따라 실린다
  if (!all.length) return sec('새 소식', muted('아직 소식이 없다.')) + webzineSec();
  const NEWS = all;
  const row = (n) => '<details class="ux-details news-entry" id="news-' + encodeURIComponent(n.at + '-' + n.ko).replace(/%/g, '') + '"><summary>'
    + `${newsFresh(n) ? '<em class="newsnew">새</em> ' : ''}<b>${esc(n.ko)}</b> <small class="qt">${esc(n.at)}${n.pin ? ' · 주요 안내' : ''}</small></summary>`
    + `<div class="muted">${n.body}</div></details>`;
  const fresh = NEWS.filter(newsFresh).length;
  const head = NEWS.slice(0, NEWS_SHOWN), rest = NEWS.slice(NEWS_SHOWN);
  return sec(`새 소식 <em>${fresh ? `새 글 ${fresh}건 · ` : ''}${NEWS.length}건</em>`, head.map(row).join('')
    + (rest.length ? `<details class="newsold"><summary>지난 소식 ${rest.length}건</summary>${rest.map(row).join('')}</details>` : ''))
    + webzineSec();
}
